import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants';
import dataModel from '../../models/DataModel';
import userService from '../../services/userService';

export default class UsersCollection extends AOCollection {
  /**
   * @param {object} filter - has the following properties:
   *  - searchString (string)
   *  - sortField (string)
   *  - ascending (boolean)
   *  - showDisabled (boolean)
   *  - companyId (number)
   *  - userType (string)
   */
  constructor(name, perPage, filter, userId, companyId, recordDescriptor, subKey, mobileDirectory) {
    super({
      name: name ? name : ReduxConstants.USERS,
      collectionType: ReduxConstants.USER,
      perPage,
      filter,
      userId,
      companyId,
      recordDescriptor,
      subKey,
    });
    this._mobileDirectory = mobileDirectory;
    this._searchString = filter && filter.searchString;
    this._pageNumber = filter && filter.pageNumber;
    this.fixupName = this.fixupName.bind(this);
  }

  static build(name, perPage, filter, userId, companyId, recordDescriptor, subKey, mobileDirectory) {
    const collection = new UsersCollection(name, perPage, filter, userId, companyId, recordDescriptor, subKey, mobileDirectory);
    const collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  fixupName(users) {
    return users.map(user => {
      user.name = user.first_name + ' ' + user.last_name;
      return user;
    });
  }
  async fetchNext(pageOverride, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      else this.page++;

      if (!this._filter) {
        this._filter = {};
      }
      const { sortField, ascending, showDisabled, userType, companyId, includeVendors } = this._filter;
      let serviceCall;
      if (this._mobileDirectory) {
        userService.mobileUsersDirectory.bind(this, options);
      }
      else {
        serviceCall = userService.search.bind(this, this._searchString, companyId ? companyId : this.companyId ? this.companyId : null, userType, includeVendors, showDisabled, sortField, ascending, this._pageNumber, this.perPage, options);
      }
      let newCollection = await this._fetchData(serviceCall, options, true, null, prefetchCallback);
      if (newCollection.isOffline) {
        return this.handleOffLineFetch(options);
      }
      newCollection.users = this.fixupName(newCollection.users);
      return newCollection;
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let collection = this.findCollection();

      let page = null;
      let perPage = null;
      
      // Get everything we already got
      if (shouldPaginate) {
        page = 1;
        if (collection && collection.perPage) {
          perPage = Math.max(this.perPage, collection.ids.length);
        }
      }
      if (!this._filter) {
        this._filter = {};
      }
      const { sortField, ascending, showDisabled, userType, companyId, includeVendors } = this._filter;
      let serviceCall;
      if (this._mobileDirectory) {
        serviceCall = userService.mobileUsersDirectory.bind(this, options);
      }
      else {
        serviceCall = userService.search.bind(this, this._searchString, companyId ? companyId : this.companyId ? this.companyId : null, userType, includeVendors, showDisabled, sortField, ascending, this._pageNumber, perPage, options);
      }
      let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
      if (newCollection.isOffline) {
        return this.handleOffLineFetch(options);
      }
      newCollection.users = this.fixupName(newCollection.users);
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/UsersCollection.js